import { useState, useEffect, useCallback } from "react";
import useApi from "./useApi";
import { getClassWiseSubjects } from "../services/SubjectServices";
import { getStudentEnrolledSubjects, createStudentSubjectsEnrollment } from "../services/StudentSubjectMappingService";

export default function useSubjectEnrollment(programId, studentId) {
  const [subjectIds, setSubjectIds] = useState([]);
  const [subjectList, setSubjectList] = useState([]);

  const { execute: fetchSubjects, loading: subjectsLoading } = useApi(getClassWiseSubjects, { showSuccess: false });
  const { execute: fetchEnrolled, loading: enrolledLoading } = useApi(getStudentEnrolledSubjects, { showSuccess: false });
  const { execute: enrollSubjects, loading: submitLoading } = useApi(createStudentSubjectsEnrollment);

  // Fetch all subjects & enrolled subjects
  useEffect(() => {
    const load = async () => {
      if (!programId || !studentId) return;
      const subjectsRes = await fetchSubjects(programId);
      setSubjectList(subjectsRes?.data?.data || []);
      const enrolledRes = await fetchEnrolled(studentId, programId);
      setSubjectIds(enrolledRes?.data?.data.map(sub => sub.subject_id.toString()) || []);
    };
    load();
  }, [programId, studentId, fetchSubjects, fetchEnrolled]);

  const toggleSubject = useCallback((e, id) => {
    setSubjectIds(prev => prev.includes(id) ? prev.filter(sid => sid !== id) : [...prev, id]);
  }, []);

  const submitEnrollment = useCallback(async () => {
    try {
      const res = await enrollSubjects({ student_id: studentId, program_id: programId, subject_ids: subjectIds });
      return res; // Return response for caller to handle if needed
    } catch (error) {
      // Error already handled by useApi hook
      throw error; // Re-throw so caller knows it failed
    }
  }, [studentId, programId, subjectIds, enrollSubjects]);

  return {
    subjectList,
    subjectIds,
    setSubjectIds,
    toggleSubject,
    submitEnrollment,
    subjectsLoading,
    enrolledLoading,
    submitLoading
  };
}
